/**
 * @typedef {"alta" | "media" | "baixa"} SeverityLevel
 */

/**
 * @typedef {Object} ReportFormData
 * @property {string} title
 * @property {string} description
 * @property {string} action
 * @property {string} severity
 */

/**
 * @typedef {Object} ReportFormErrors
 * @property {string=} title
 * @property {string=} description
 * @property {string=} action
 * @property {string=} severity
 */

/**
 * Valida os dados do formulário de relatório.
 *
 * @param {ReportFormData} data
 * @returns {ReportFormErrors}
 */
export function validateReport(data) {
  const errors = {};

  if (!data.title || data.title.trim() === "") {
    errors.title = "Título é obrigatório";
  }

  if (!["alta", "media", "baixa"].includes(data.severity)) {
    errors.severity = "Selecione uma severidade válida";
  }

  return errors;
}
